<template>
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div class="lef-one">
        <a-select
            v-model:value="searchForm.hid"
            :dropdownMatchSelectWidth="false"
            :filter-option="false"
            allowClear
            placeholder="请选择房间"
            show-search
            style="width: 100%"
            @change="getTableData"
            @focus="searchRoom"
            @search="roomFilter"
        >
          <a-select-option
              v-for="(item, index) in roomList"
              :key="index"
              :value="item.id"
          >{{ item.name }}
          </a-select-option
          >
        </a-select>
      </div>
      <div class="lef-one">
        <a-input-search
            v-model:value="searchForm.order_no"
            :loading="searchLoading"
            allowClear
            placeholder="请输入订单号"
            @search="getTableData"
        >
        </a-input-search>
      </div>
      <div class="lef-one">
        <a-input-search
            v-model:value="searchForm.sn"
            :loading="searchLoading"
            allowClear
            placeholder="请输入设备SN"
            @search="getTableData"
        >
        </a-input-search>
      </div>
      <div class="lef-one-no-shadow">
        <a-button type="link" @click="handleReset">重置筛选</a-button>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="searchLoading"
      :pagination="false"
      :scroll="{ x: columns.length > 6 ? 1500 : 0, y: tableHeight }"
      class="table"
      size="small"
  >
    <!-- <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'operation'">
        <a-button type="link" @click="handleEdit(record)">修改</a-button>
      </template>
    </template> -->
  </a-table>

  <!-- 分页 -->
  <MyPagination
      :pageTotal="pageTotal"
      class="pagination"
      @onShowSizeChange="onShowSizeChange"
      @pageChange="pageChange"
  />
  <!-- </div> -->
</template>

<script>
import {onMounted, reactive, toRefs} from "vue";
import {getHouseList, houseOpenlist} from "@/api/api";
// import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index"; //VUEX
import router from "@/router/index";

export default {
  //   components: {
  //     ExclamationCircleOutlined,
  //   },
  setup() {
    let {countTable, imgCut} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        hid: [],
        sn: "",
        order_no: "",
        start: 0,
        limit: store.getters.getPageSize,
      },
      roomList: [],
      searchRoom() {
        getHouseList({
          start: 0,
          limit: 99,
        }).then((res) => {
          search.roomList = res.data.list;
        });
      },
      throttle: false,
      throttleInput: "",
      roomFilter(input) {
        search.throttleInput = input;
        if (search.throttle) {
          return;
        }
        search.throttle = true;
        setTimeout(() => {
          getHouseList({
            start: 0,
            limit: 99,
            name: search.throttleInput,
          }).then((res) => {
            search.roomList = res.data.list;
            search.throttle = false;
          });
        }, 1000);
      },
      handleReset() {
        search.searchForm.hid = [];
        search.searchForm.sn = "";
        search.searchForm.order_no = "";
        table.getTableData();
      },
    });

    // 表格
    const table = reactive({
      tableHeight: "",
      dataSource: [],
      initColumns: [],
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "SN",
          dataIndex: "sn",
          key: "sn",
        },
        {
          title: "房间",
          dataIndex: "hname",
          key: "hname",
          customRender: ({text}) => {
            if (!text) {
              return "-";
            } else {
              return text;
            }
          },
        },
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "开门方式",
          dataIndex: "type_text",
          key: "type_text",
        },
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          customRender: ({text}) => {
            if (!text) {
              return "-";
            } else {
              return text;
            }
          },
        },
        {
          title: "开门时间",
          dataIndex: "open_date",
          key: "open_date",
        },
      ],
      // upTableData() {
      //   search.searchLoading = true;
      //   houseOpenlist(search.searchForm)
      //     .then((res) => {
      //       table.dataSource = res.data.list;
      //       pagination.pageTotal = res.data.count;
      //       search.searchLoading = false;
      //     })
      //     .catch(() => {
      //       search.searchLoading = false;
      //     });
      // },
      getTableData() {
        search.searchLoading = true;
        houseOpenlist(search.searchForm)
            .then((res) => {
              table.dataSource = [];
              for (let item of res.data.list) {
                table.dataSource.push(...item.list);
              }
              pagination.pageTotal = res.data.count;
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    onMounted(() => {
      if (router.currentRoute.value.query.sn) {
        search.searchForm.sn = router.currentRoute.value.query.sn;
      }
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 10;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.weixin {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .QR {
  }

  .info {
    font-weight: bold;
  }

  .tips {
    color: #f5a623;
    margin-top: 20px;
  }
}

.drawer {
  position: absolute;

  .header {
    height: 60px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .title {
    }

    .status {
    }
  }

  .content {
    padding: 20px;

    .title {
      padding: 10px 0;
    }

    .info {
      display: flex;
      padding: 7px 0;

      .lef {
        width: 100px;
      }

      .rig {
        width: 400px;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 450px;
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .lef {
    }

    .rig {
    }
  }
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}

.bar {
  border-radius: 10px;
  padding: 2px 10px;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  padding: 0 10px;

  .add-lef {
    flex: 1;
    margin-right: 40px;
  }

  .add-rig {
    flex: 1;
  }
}

.checkbox {
  margin-left: 90px;
  margin-bottom: 24px;
}
</style>